import './styles/SolarSim.css';
import { SimulationProvider } from "./contexts/Simulation";
import Stepper from './Stepper';


const SolarSim = ({ initialProps }) => {

  return (
    <div className="solarsim">
      <SimulationProvider>
        <Stepper initialProps={initialProps}/>
      </SimulationProvider>
    </div>
  );
}

export default SolarSim;
